import { c as _c } from "react/compiler-runtime";
import getThemeStyles from "src/lib/styling/getThemeStyles";
import styles from "./KinoklubbPosterBanner.module.css";
import { locale } from "@locale";
import classNames from "classnames";
type KinoklubbPosterBannerProps = {
  className?: string;
};
export default function KinoklubbPosterBanner(t0) {
  const $ = _c(4);
  const {
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    const themeStyles = getThemeStyles(styles);
    t1 = classNames(styles.kinoklubbBanner, className, themeStyles);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className={t1}>{locale.kinoklubb.posterbanner}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}